export const baseColor = '#292C35';
